(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rtl-article-commerce"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-rtl-products-drawer]').forEach((drawer) => {
    const toggle = drawer.querySelector('[data-rtl-products-toggle]');
    const close = drawer.querySelector('[data-rtl-products-close]');

    const setOpen = (open) => {
      drawer.classList.toggle('is-open', open);
      toggle?.setAttribute('aria-expanded', String(open));
    };

    toggle?.addEventListener('click', () => setOpen(!drawer.classList.contains('is-open')));
    close?.addEventListener('click', () => setOpen(false));

    document.addEventListener('click', (event) => {
      if (!drawer.contains(event.target)) setOpen(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setOpen(false);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rtl-home-commerce"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-rtl-products-drawer]').forEach((drawer) => {
    const toggle = drawer.querySelector('[data-rtl-products-toggle]');
    const close = drawer.querySelector('[data-rtl-products-close]');

    const setOpen = (open) => {
      drawer.classList.toggle('is-open', open);
      toggle?.setAttribute('aria-expanded', String(open));
    };

    toggle?.addEventListener('click', () => setOpen(!drawer.classList.contains('is-open')));
    close?.addEventListener('click', () => setOpen(false));

    document.addEventListener('click', (event) => {
      if (!drawer.contains(event.target)) setOpen(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setOpen(false);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
